<template>
  <v-sheet class="pa-4 h-100">
    <v-sheet outlined class="rounded overflow-hidden h-100 d-flex flex-column">
      <div
        class="pa-2 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <h3>Manage Companies</h3>
        <v-btn @click="update()" small color="primary"
          ><v-icon left>mdi-plus</v-icon> Add Company
        </v-btn>
        <v-spacer v-if="!$vuetify.breakpoint.xs"></v-spacer>
        <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
          <v-text-field
            hide-details
            outlined
            v-model="options.search"
            dense
            class="search-bar"
            placeholder="Search in companies..."
            clearable
            prepend-inner-icon="mdi-magnify"></v-text-field>
        </v-sheet>
      </div>
      <v-data-table
        class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table"
        :footer-props="{
          showFirstLastPage: true,
          firstIcon: 'mdi-chevron-double-left',
          lastIcon: 'mdi-chevron-double-right',
          prevIcon: 'mdi-chevron-left',
          nextIcon: 'mdi-chevron-right',
          itemsPerPageText: 'Row/Page',
          itemsPerPageOptions: [15, 30, 50, 100, 200, 300, 400, 500, -1],
        }"
        :headers="companyHeaders"
        :items="entries"
        :options.sync="options"
        @click:row="update"
        :loading="loading"
        :server-items-length="total">
        <template v-slot:[`item.name`]="{ item }">
          <h4 :class="item.isSuspended ? 'error--text' : ''">
            {{ item.name }}
          </h4>
        </template>

        <template v-slot:[`item.owner.firstName`]="{ item }">
          <user-avatar
            v-if="item.owner && item.owner.firstName"
            :user="item.owner"
            disable-open-link
            hide-roles
            show-no-user></user-avatar>
        </template>

        <template v-slot:[`item.projectsCount`]="{ item }">

          <CountProgress
            :count="item.facilitiesLimitUsed"
            :limit="item.facilitiesLimitCount"
            :unlimited="+item.facilitiesLimitCount === -1"
            :minWidth="160"
            icon="mdi mdi-domain"
          />
        </template>
        <template v-slot:[`item.usersCount`]="{ item }">
       
          <CountProgress
            :count="item.usersCount??0"
            :limit="item.usersLimitCount"
            :unlimited="+item.usersLimitCount === -1"
            :minWidth="160"
            icon="mdi-account-multiple-outline"
          />
        </template>
        <!-- <template v-slot:[`item.projectModels`]="{ item }">
          <CountProgress
            :count="item.smallModelsLimitUsed??0"
            :limit="item.smallModelsLimitCount"
            :unlimited="+item.smallModelsLimitCount === -1"
            :minWidth="160"
            icon="mdi-folder-cog-outline"
          />
        </template>
        <template v-slot:[`item.scanUploads`]="{ item }">
            <CountProgress
              :count="item.scanUploadLimitUsed??0"
              :limit="item.scanUploadLimit"
              :unlimited="+item.scanUploadLimit === -1"
              :minWidth="160"
              icon="mdi-upload"
            />

        </template>
        <template v-slot:[`item.scanDownloads`]="{ item }">
          <CountProgress
            :count="item.scanDownloadUsed??0"
            :limit="item.scanDownloadLimit"
            :unlimited="+item.scanDownloadLimit === -1"
            :minWidth="160"
            type="fileSize"
            icon="fa-solid fa-cloud-arrow-down"
          />
        </template> -->
        <template v-slot:[`item.modules`]="{ item }">
        
              <div
                class="d-flex align-center"
                @click.stop="openActivityLevels(item)"
               
                style="cursor: pointer; min-width: 200px; gap: 8px;"
              >
                <template v-if="activityLoading">
                  <v-skeleton-loader
                    type="text"
                    width="160"
                    class="mt-1"
                  ></v-skeleton-loader>
                  <v-progress-circular
                    indeterminate
                    size="16"
                    width="2"
                    color="primary"
                  ></v-progress-circular>
                </template>
                <template v-else>
                  <template v-if="hasActivityData(item)">
                    <ActivitySparkline
                      :series="getActivitySeries(item)"
                      :color="getActivityGradient(item)[0]"
                    />
                  </template>
                  <template v-else>
                    <div class="no-activity-message d-flex align-center">
                      <v-icon class="mr-1 grey--text text--lighten-1" small>mdi-chart-bar</v-icon>
                      <span class="text-caption grey--text text--darken-1">No activities recorded</span>
                    </div>
                  </template>
                </template>
              </div>
        </template>
        <template v-slot:[`item.companyType`]="{ item }">
          <company-type-c :type="item.companyType" small></company-type-c>
        </template>
        <template v-slot:[`item.region`]="{ item }">
          <div class="d-flex justify-center">      <img class="mr-1" :src="regions.find(e=>e.id==item.region)?.flag" style="height: 20px;"/> <span>{{regions.find(e=>e.id==item.region)?.name }}</span> </div>
        </template>
         <template v-slot:[`item.customDomainName`]="{ item }">
          <div class="d-flex justify-center" >   
             <v-icon v-if="item.customDomainName"   color="green">mdi-check-circle-outline</v-icon>  </div>
        </template>
        <template v-slot:[`item.hasCustomStorage`]="{ item }">
          <div class="d-flex justify-center" >   
             <v-icon v-if="item.hasCustomStorage"   color="green">mdi-check-circle-outline</v-icon>  </div>
        </template>
        <template v-slot:[`item.createDate`]="{ item }">
          <div v-if="item.createDate">
            {{ $formatDate(item.createDate) }}
          </div>
        </template>

        <template v-slot:[`item.licenseExpiryDate`]="{ item }">
          <div
            v-if="item.licenseExpiryDate"
            class="d-flex align-center"
            style="gap: 0.4rem"
            :class="{
              'error--text': item.isAboutToExpire,
            }">
            <v-icon small color="error" v-if="item.isAboutToExpire">mdi-alert</v-icon>
            {{ $formatDate(item.licenseExpiryDate) }}
            <span v-if="item.isAboutToExpire"
              >({{ item.daysUntilExpiry == 0 ? 'Expired' : item.daysUntilExpiry + ' days' }})</span
            >
          </div>
        </template>

        <template v-slot:[`item.isSuspended`]="{ item }">
          <v-chip x-small :color="item.isSuspended ? 'error' : 'success'">
            <v-icon left x-small> {{ item.isSuspended ? 'mdi-block-helper' : 'mdi-check' }}</v-icon>
            {{ item.isSuspended ? 'Suspended' : 'Active' }}</v-chip
          >
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu dense offset-x right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                <v-icon size="16px">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list class="more-options-menu" dense>
              <v-list-item v-has="permissions.CompaniesManagement.Update" @click="update(item)" dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="success">mdi-pencil-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Update</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="suspend(item)" dense v-has="permissions.CompaniesManagement.Delete">
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-block-helper</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ item.isSuspended ? 'Reactive' : 'Suspend' }}</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="impersonate(item)" dense v-has="permissions.CompaniesManagement.Impersonate">
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small  >  fa-solid fa-people-arrows</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Impersonate </v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="resendInvitation(item)" dense v-has="permissions.CompaniesManagement.Update">
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small  >mdi-email-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    Resend Invitation</v-list-item-title
                  >
                </v-list-item-content>
              </v-list-item>
              <v-list-item @click="openDeleteDialog(item)" dense v-has="permissions.CompaniesManagement.Delete">
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-delete-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete Company</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">No Data Available!</p>
          </div>
        </template>

        <template v-slot:loading>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">Loading Companies...</p>
          </div>
        </template>
      </v-data-table>
      <EditCompany ref="editCompany"></EditCompany>
    </v-sheet>
    <v-dialog v-model="impersonateDialog" max-width="800px">
      <v-card >
        <v-card-title class="headline" style="background-color: orange;color: white;">
          <i   class="fa-solid fa-triangle-exclamation mr-2"></i> Impersonation Mode Warning
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-5">
       <p>You are about to enter Impersonation Mode, which allows you to act on behalf of another user.</p>   
          <ul>
            <li> Actions taken during impersonation are logged and attributed to you.</li>
            <li> Use this feature responsibly—any unauthorized access or misuse may result in disciplinary action.</li>
            <li> Ensure you have the necessary permissions before proceeding.</li>
          </ul>
          <div  class="mt-5">
            <b>If you proceed, you will temporarily assume the identity of the selected Company Owner. To exit impersonation, use the "Exit Impersonation" option. Do you want to continue?</b>
          </div>


        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
        <v-btn text @click="impersonateModeConfirm" :loading="loading"> Confirm </v-btn>
        <v-spacer></v-spacer>
        <v-btn  color="primary" text @click="impersonateDialog=false"> Cancel </v-btn>
      </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Delete Company Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="600px">
      <v-card>
        <v-card-title class="headline">
          <v-icon left color="error" class="mr-2">mdi-alert</v-icon>
          Delete Company
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <p class="mb-4">
            You are about to permanently delete the company
            <b>{{ deleteTargetName }}</b>. Their data will be archived and no longer accessible in the application.
          </p>
          <p class="mb-2">To confirm, please type the company name exactly:</p>
          <v-text-field
            v-model="deleteConfirmName"
            outlined
            dense
            hide-details
            :label="confirmDeleteLabel"
          />
          <div class="caption mt-2" :class="{ 'error--text': deleteConfirmName && deleteConfirmName !== deleteTargetName }">
            {{ deleteConfirmName && deleteConfirmName !== deleteTargetName ? 'Name does not match' : '\u00A0' }}
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text @click="deleteDialog = false" :disabled="deleteLoading">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="error" :loading="deleteLoading" :disabled="deleteConfirmName !== deleteTargetName" @click="confirmDelete">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ActivityLevelModal ref="activityModal" />
  </v-sheet>
</template>

<style scoped>
.activity-sparkline {
  opacity: 0.9;
}

.activity-sparkline :deep(.v-sparkline__fill) {
  opacity: 0.2;
  transition: opacity 0.3s ease;
}

.activity-sparkline:hover :deep(.v-sparkline__fill) {
  opacity: 0.3;
}

.custom-apex-style :deep(.v-sparkline__fill) {
  /* Simulate ApexCharts gradient fill */
  opacity: 0.07; /* much less opacity */
}
.custom-apex-style :deep(.v-sparkline__line) {
  stroke-width: 2.5px;
  stroke: #1976d2 !important; /* solid border, adjust color as needed */
  stroke-dasharray: none;
}
/* Markers for sparkline points */
.custom-apex-style :deep(.v-sparkline__dot) {
  display: block;
  fill: #fff;
  stroke: #1976d2;
  stroke-width: 2px;
}

.custom-apex-style :deep(.v-sparkline__line) {
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
}
/* No markers in v-sparkline by default */
/* Tooltip styling is not directly supported in v-sparkline */


.activity-sparkline :deep(.v-sparkline__line) {
  stroke-width: 2px;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.no-activity-message {
  min-width: 160px;
  padding: 4px 8px;
  border-radius: 4px;
  background-color: #f9f9f9;
  opacity: 0.8;
  border: 1px dashed #e0e0e0;
}
</style>

<script>
import ActivitySparkline from '@/components/ActivitySparkline.vue';
import ActivityLevelModal from '@Company/components/ActivityLevelModal.vue';
import UserAvatar from '@Share/components/UserAvatar.vue';
import companyHeaders from '@Company/config/company.headers';
import { mapGetters } from 'vuex';
import CompanyTypeC from '@Company/components/CompanyType.vue';
import EditCompany from '@Company/components/EditCompany.vue';
import CountProgress from '@Company/components/CountProgress.vue';
import permissions from '@Share/config/permissions';
import { CompanyType } from '@Share/config/enums';
import { $formatDate,$has } from '@Utils';
import moduleActivityLogService from '@Company/service/module-activitylog.service';
import { log as debugLog, warn as debugWarn, error as debugError } from '@/utils/debugLogger';

  export default {

    name: 'company-list',
    data() {
      return {
        companyHeaders,
        permissions,
        CompanyType,
        timerId: null,
        impersonateDialog:false,
        selectedImpersonateCompanyId:'',
        deleteDialog: false,
        deleteTarget: null,
        deleteConfirmName: '',
        deleteLoading: false,
        activityDialog: false,
        activityItem: null,
        activityCache: new Map(),
        activityLoading: false,
        activityModules: [
          { key: 'viewer', label: 'Viewer', icon: 'mdi-eye-outline' },
          { key: 'corrosionAI', label: 'Corrosion AI', icon: 'mdi-robot-outline' },
          { key: 'askAva', label: 'Ask AVA', icon: 'mdi-account-question-outline' },
          { key: 'askAvaDashboards', label: 'Ask AVA Dashboards', icon: 'mdi-view-dashboard-outline' },
          { key: 'inspection', label: 'Inspection Module', icon: 'mdi-magnify-scan' },
          { key: 'inspectionDashboards', label: 'Inspection Dashboards', icon: 'mdi-view-dashboard-outline' },
          { key: 'taskBoards', label: 'Task Boards', icon: 'mdi-view-kanban' },
          { key: 'customDashboards', label: 'Custom Dashboards', icon: 'mdi-view-dashboard-variant-outline' },
          { key: 'scanDownloads', label: 'Scan Downloads', icon: 'mdi-download' },
        ],
        // Configurable thresholds and colors for activity visuals; backend can adjust via API later if needed
        activityConfig: {
          thresholds: { high: 75, medium: 40 },
          colors: {
            high: { strong: 'rgba(129, 199, 132, 0.9)', soft: 'rgba(129, 199, 132, 0.4)' },
            medium: { strong: 'rgba(255, 224, 130, 0.9)', soft: 'rgba(255, 224, 130, 0.4)' },
            low: { strong: 'rgba(239, 154, 154, 0.9)', soft: 'rgba(239, 154, 154, 0.4)' },
          },
        },
      };
    },
    computed: {
      ...mapGetters('COMPANY', {
        loading: 'GET_LOADING',
        entries: 'GET_ENTRIES',
        total: 'GET_TOTAL',
      }),
      regions(){
        return this.$store.getters['COMPANY/GET_REGIONS'];
      },
      deleteTargetName(){
        return this.deleteTarget && this.deleteTarget.name ? this.deleteTarget.name : '';
      },
      confirmDeleteLabel(){
        const n = this.deleteTargetName;
        return n ? `Type "${n}" to confirm` : 'Type company name to confirm';
      },
      options: {
        get() {
          return this.$store.getters['COMPANY/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('COMPANY/SET_OPTIONS', val);
        },
      },
    },
    methods: {
      $has,
      $formatDate,
      openActivityLevels(item){
        if (this.$refs.activityModal) {
          this.$refs.activityModal.open(item || null);
        }
      },
      getActivitySeries(item){
        if (!item) return [];
        // Prefer explicit series if provided by backend (support various shapes)
        const a = item.activity || {};
        const candidates = [
          item.activitySeries,
          item.activitySparkline,
          a.series,
          a.timeline,
          a.timeseries,
          a.timeSeries,
          a.history,
          (a.series && a.series.values),
          (a.series && a.series.data),
        ];
        for (const c of candidates){
          if (Array.isArray(c) && c.length){
            const parsed = this.getNumericSeries(c);
            if (parsed.length) return this.normalizeBarSeries(parsed);
          }
        }
        // Fallback: build series from module activity values
        const seriesFromModules = this.activityModules.map(m => this.getActivityValue(item, m.key));
        if (seriesFromModules.some(v => v > 0)) return this.normalizeBarSeries(seriesFromModules);
        // Temporary demo data if no values exist
        return this.normalizeBarSeries(this.ensureRandomSeries(item));
      },
      // Ensure series is suitable for Apex bar sparkline
      normalizeBarSeries(series, maxLen = 24){
        if (!Array.isArray(series)) return [];
        const cleaned = series
          .map(v => Number(v))
          .filter(v => Number.isFinite(v))
          .map(v => Math.max(0, Math.round(v)));
        // Keep only the most recent maxLen values
        return cleaned.length > maxLen ? cleaned.slice(cleaned.length - maxLen) : cleaned;
      },
      ensureRandomSeries(item){
        const key = (item && (item.id || item._id || item.name)) || Math.random().toString(36).slice(2);
        if (this.activityCache.has(key)) return this.activityCache.get(key);
        const len = 12;
        const base = this.randomInt(20, 60);
        const arr = Array.from({ length: len }, (_, i) => {
          const swing = Math.sin(i / 2) * this.randomInt(5, 20);
          return Math.max(0, Math.min(100, Math.round(base + swing + this.randomInt(-10, 10))));
        });
        this.activityCache.set(key, arr);
        return arr;
      },
      randomInt(min, max){
        return Math.floor(Math.random() * (max - min + 1)) + min;
      },
      getActivityValue(item, key){
        if (!item) return 0;
        const cap = String(key).charAt(0).toUpperCase() + String(key).slice(1);
        // Special-case: scanDownloads can be derived from used/limit
        if (key === 'scanDownloads'){
          const used = Number(item.scanDownloadsUsed ?? 0) || 0;
          const limit = Number(item.scanDownloadsLimit ?? 100) || 100;
          return Math.max(0, Math.min(100, Math.round((limit ? (used/limit)*100 : 0))));
        }
        // Nested paths
        const nestedPaths = [
          ['activity', key],
          ['activity', `${key}Level`],
          ['activity', 'levels', key],
          ['modulesActivity', key],
          ['modulesActivity', `${key}Level`],
        ];
        for (const path of nestedPaths){
          let ref = item;
          let ok = true;
          for (const p of path){
            if (ref && Object.prototype.hasOwnProperty.call(ref, p)){
              ref = ref[p];
            } else { ok = false; break; }
          }
          if (ok && isFinite(ref)){
            const v = Number(ref) || 0;
            return Math.max(0, Math.min(100, Math.round(v)));
          }
        }
        // Flat candidates
        const flat = [
          `${key}Activity`,
          `activity${cap}`,
          `${key}ActivityLevel`,
          `${key}Level`,
          `${key}`,
        ];
        for (const k of flat){
          if (k in item && isFinite(item[k])){
            const v = Number(item[k]) || 0;
            return Math.max(0, Math.min(100, Math.round(v)));
          }
        }
        return 0;
      },
      getActivitySummary(item){
        const s = this.getActivitySeries(item);
        if (!s || !s.length) return { min: 0, max: 0, avg: 0, last: 0, sum: 0 };
        const min = Math.min(...s);
        const max = Math.max(...s);
        const sum = s.reduce((a, b) => a + (Number(b) || 0), 0);
        const avg = Math.round(sum / s.length);
        const last = Math.round(s[s.length - 1]);
        return { min, max, avg, last, sum };
      },
      getActivityChipColor(item){
        const { last } = this.getActivitySummary(item);
        if (last >= 75) return 'success';
        if (last >= 40) return 'warning';
        return 'grey darken-1';
      },
      getActivityTooltip(item){
        const totalActivities = this.getTotalActivities(item);
        // Format the number with thousands separator
        const formattedTotal = totalActivities.toLocaleString();
        return `Total Activities: ${formattedTotal} | Click for details`;
      },
      getTotalActivities(item) {
        // Check if the company has activity data with total count
        if (item && item.activity) {
          // Try to get total from various possible properties
          const candidates = [
            item.activity.totalActivities,
            item.activity.total,
            item.activity.count,
            item.activity.eventsCount,
            item.activity.activityCount
          ];
          
          for (const candidate of candidates) {
            if (typeof candidate === 'number' && !isNaN(candidate)) {
              return candidate;
            }
          }
          
          // If we have series data with date and total objects
          if (item.activity.series && Array.isArray(item.activity.series)) {
            // If series contains objects with total, sum them up
            if (item.activity.series.length > 0 && typeof item.activity.series[0] === 'object' && 'total' in item.activity.series[0]) {
              return item.activity.series.reduce((sum, point) => sum + (point.total || 0), 0);
            }
            
            // If series is just numbers, sum them up
            if (item.activity.series.length > 0 && typeof item.activity.series[0] === 'number') {
              return item.activity.series.reduce((sum, val) => sum + (val || 0), 0);
            }
          }
        }
        
        // Fallback to sum from activity summary
        const { sum } = this.getActivitySummary(item);
        return sum || 0;
      },
      getActivityTrendDelta(item){
        const s = this.getActivitySeries(item);
        if (!s || s.length < 2) return 0;
        return Math.round((s[s.length - 1] || 0) - (s[0] || 0));
      },
      getActivityTrendIcon(item){
        const d = this.getActivityTrendDelta(item);
        if (d > 2) return 'mdi-trending-up';
        if (d < -2) return 'mdi-trending-down';
        return 'mdi-trending-neutral';
      },
      getActivityTrendColor(item){
        const d = this.getActivityTrendDelta(item);
        if (d > 2) return 'success';
        if (d < -2) return 'error';
        return 'grey';
      },
      getActivityGradient(item){
        const last = this.getActivitySummary(item).last;
        const color = this.getActivityLevelColor(last);
        // Use a 2-stop gradient so the line/fill mirrors the activity level color
        return [color, color];
      },
      getActivityLevelColor(val){
        const v = Number(val) || 0;
        if (v >= 75) return '#43a047'; // green darken-1
        if (v >= 40) return '#ffb300'; // amber darken-1
        return '#e53935'; // red darken-1
      },
      getModuleSeries(item, moduleKey){
        if (!item) return [];
        // Prefer explicit series from possible shapes
        const mod = (item.activity && item.activity.modules && item.activity.modules[moduleKey]) || null;
        const direct = item[`${moduleKey}Series`];
        const seriesByModule = (item.activity && item.activity.seriesByModule && item.activity.seriesByModule[moduleKey]);
        const explicit = (mod && Array.isArray(mod.series) && mod.series)
          || (Array.isArray(seriesByModule) && seriesByModule)
          || (Array.isArray(direct) && direct);
        if (explicit && explicit.length) return this.getNumericSeries(explicit);
        // Fallback: synthesize around current module value
        const base = this.getActivityValue(item, moduleKey) || 0;
        return this.ensureRandomModuleSeries(item, moduleKey, base);
      },
      getModuleGradient(item, moduleKey){
        const s = this.getModuleSeries(item, moduleKey);
        const last = s && s.length ? Math.round(s[s.length - 1]) : this.getActivityValue(item, moduleKey);
        const { strong, soft } = this.getSoftActivityLevelColor(last);
        // Softer, less saturated gradient (line/fill)
        return [strong, soft];
      },
      getModuleLast(item, moduleKey){
        const s = this.getModuleSeries(item, moduleKey);
        if (s && s.length) return Math.round(s[s.length - 1]);
        return this.getActivityValue(item, moduleKey);
      },
      getModuleTrendDelta(item, moduleKey){
        // Prefer explicit delta from API when available
        const mod = (item && item.activity && item.activity.modules && item.activity.modules[moduleKey]) || null;
        const trends = (item && item.activity && item.activity.trends) || null;
        const explicit = (mod && (mod.delta ?? mod.trendDelta ?? mod.change))
          ?? (trends && trends[moduleKey]);
        if (isFinite(explicit)) return Math.round(Number(explicit) || 0);
        const s = this.getModuleSeries(item, moduleKey);
        if (!s || s.length < 2) return 0;
        return Math.round((s[s.length - 1] || 0) - (s[0] || 0));
      },
      getModuleTrendIcon(item, moduleKey){
        const d = this.getModuleTrendDelta(item, moduleKey);
        if (d > 2) return 'mdi-trending-up';
        if (d < -2) return 'mdi-trending-down';
        return 'mdi-trending-neutral';
      },
      getModuleTrendColor(item, moduleKey){
        const d = this.getModuleTrendDelta(item, moduleKey);
        if (d > 2) return 'success';
        if (d < -2) return 'error';
        return 'grey';
      },
      getModuleCount(item, moduleKey){
        if (!item) return 0;
        const mod = (item.activity && item.activity.modules && item.activity.modules[moduleKey]) || null;
        const countsByModule = (item.activity && item.activity.counts) || item.countsByModule || null;
        if (mod && isFinite(mod.count)) return Number(mod.count) || 0;
        if (countsByModule && isFinite(countsByModule[moduleKey])) return Number(countsByModule[moduleKey]) || 0;
        const candidates = [
          `${moduleKey}Count`,
          `${moduleKey}ActivityCount`,
          `${moduleKey}Events`,
          `${moduleKey}Total`,
          `${moduleKey}Number`,
        ];
        // Module object fallbacks
        if (mod && isFinite(mod.events)) return Number(mod.events) || 0;
        if (mod && isFinite(mod.total)) return Number(mod.total) || 0;
        for (const k of candidates){
          if (k in item && isFinite(item[k])) return Number(item[k]) || 0;
        }
        // Fallback: use last value of series as an approximate count
        return this.getModuleLast(item, moduleKey) || 0;
      },
      getSoftActivityLevelColor(val){
        const v = Number(val) || 0;
        const cfg = this.activityConfig || { thresholds: { high: 75, medium: 40 }, colors: {
          high: { strong: 'rgba(129, 199, 132, 0.9)', soft: 'rgba(129, 199, 132, 0.4)' },
          medium: { strong: 'rgba(255, 224, 130, 0.9)', soft: 'rgba(255, 224, 130, 0.4)' },
          low: { strong: 'rgba(239, 154, 154, 0.9)', soft: 'rgba(239, 154, 154, 0.4)' },
        } };
        if (v >= cfg.thresholds.high) return cfg.colors.high;
        if (v >= cfg.thresholds.medium) return cfg.colors.medium;
        return cfg.colors.low;
      },
      getNumericSeries(series){
        if (!Array.isArray(series)) return [];
        // Handle arrays of numbers or arrays of objects with common value keys
        if (series.length && typeof series[0] === 'number'){
          return series.map(n => Number(n) || 0);
        }
        const valueKeys = ['value', 'v', 'y', 'val', 'score', 'level'];
        return series.map(p => {
          if (typeof p === 'number') return Number(p) || 0;
          if (p && typeof p === 'object'){
            for (const k of valueKeys){
              if (isFinite(p[k])) return Number(p[k]) || 0;
            }
          }
          return 0;
        });
      },
      ensureRandomModuleSeries(item, moduleKey, baseValue){
        const itemKey = (item && (item.id || item._id || item.name)) || 'row';
        const key = `${itemKey}:${moduleKey}`;
        if (this.activityCache.has(key)) return this.activityCache.get(key);
        const len = 12;
        const center = baseValue || this.randomInt(20, 60);
        const arr = Array.from({ length: len }, (_, i) => {
          const swing = Math.cos(i / 2.5) * this.randomInt(5, 18);
          return Math.max(0, Math.min(100, Math.round(center + swing + this.randomInt(-10, 10))));
        });
        this.activityCache.set(key, arr);
        return arr;
      },
      getDataDebounced() {
        if (this.timerId == null) {
          this.timerId = -1;
          this.$store.dispatch('COMPANY/GET');
          return;
        }
        // cancel pending call
        clearTimeout(this.timerId);

        // delay new call 400ms
        this.timerId = setTimeout(() => {
          this.$store.dispatch('COMPANY/GET');
        }, 400);
      },
      fetchActivityData() {
        // Only proceed if we have companies
        if (!this.entries || this.entries.length === 0) return;
        
        // Extract company IDs
        const companyIds = this.entries.map(company => company.id).filter(Boolean);
        if (companyIds.length === 0) return;
        
        // Set loading state
        this.activityLoading = true;
        
        // Call the activity log service
        moduleActivityLogService.getSummary(companyIds)
          .then(response => {
            if (response && response.data) {
              // Process the activity data
              this.processActivityData(response.data);
            }
          })
          .catch(error => {
            debugError('Error fetching activity data:', error);
          })
          .finally(() => {
            this.activityLoading = false;
          });
      },
      hasActivityData(item) {
        if (!item || !item.id) return false;
        
        // Check if the company has activity data in the cache
        const activityItem = this.activityCache.get(item.id);
        if (activityItem && Array.isArray(activityItem) && activityItem.length > 0) {
          return true;
        }
        
        // Check if the company has activity data in its activity property
        if (item.activity && item.activity.series && Array.isArray(item.activity.series) && item.activity.series.length > 0) {
          return true;
        }
        
        return false;
      },
      processActivityData(activityData) {
        if (!Array.isArray(activityData) || !this.entries) return;
        
        // Create a map for quick lookup
        const activityMap = new Map();
        activityData.forEach(item => {
          if (item && item.companyId) {
            activityMap.set(item.companyId, item);
          }
        });
        
        // Update the activity cache with the new data
        this.entries.forEach(company => {
          if (!company || !company.id) return;
          
          const activityItem = activityMap.get(company.id);
          if (activityItem) {
            // Process the series data - convert to format needed by ActivitySparkline
            let processedSeries = [];
            if (activityItem.series && Array.isArray(activityItem.series)) {
              // If series contains objects with date and total, extract the totals
              if (activityItem.series.length > 0 && typeof activityItem.series[0] === 'object') {
                processedSeries = activityItem.series.map(point => point.total || 0);
              } else {
                processedSeries = activityItem.series;
              }
            }
            
            // Store the processed series data in the cache
            this.activityCache.set(company.id, processedSeries);
            
            // Update company with activity data if available
            if (!company.activity) company.activity = {};
            company.activity = { 
              ...company.activity, 
              ...activityItem,
              series: processedSeries
            };
            
            // If there's module-specific data, update that too
            if (activityItem.modules) {
              if (!company.activity.modules) company.activity.modules = {};
              company.activity.modules = { ...company.activity.modules, ...activityItem.modules };
            }
          }
        });
      },
      update(companyItem = null) {
        // if (companyItem && companyItem.companyType == CompanyType.Management) {
        //   return;
        // }
        this.$refs.editCompany.open(companyItem ? companyItem.id : null, true);
      },
      impersonate(company){
        this.selectedImpersonateCompanyId=company.id;
        this.impersonateDialog=true;
       
      },
      impersonateModeConfirm(){
        this.$store.dispatch('COMPANY/IMPERSONATE',this.selectedImpersonateCompanyId).then(()=>{
          location.href='/';
        });
        this.selectedImpersonateCompanyId='';
      },
      resendInvitation(company){
        this.$store.dispatch('COMPANY/RESEND_INVITATION',company.id);
      },
      openDeleteDialog(company){
        this.deleteTarget = company || null;
        this.deleteConfirmName = '';
        this.deleteDialog = true;
      },
      confirmDelete(){
        if (!this.deleteTarget || this.deleteConfirmName !== this.deleteTarget.name) return;
        this.deleteLoading = true;
        this.$store.dispatch('COMPANY/DELETE', this.deleteTarget)
          .then(() => {
            this.deleteDialog = false;
            this.deleteTarget = null;
            this.deleteConfirmName = '';
            this.$store.dispatch('COMPANY/GET');
          })
          .finally(() => {
            this.deleteLoading = false;
          });
      },
      suspend(company) {
        this.$dialog.error({
          text: `Are You Sure You Want to ${
            company.isSuspended ? 'Reactive' : 'Suspend'
          } This Company?`,
          title: `${company.isSuspended ? 'Reactive' : 'Suspend'} Company`,
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                return this.$store.dispatch('COMPANY/SUSPEND', {
                  id: company.id,
                  status: !company.isSuspended,
                });
              },
            },
          },
        });
      },
    },
    watch: {
      options: {
        deep: true,
        handler() {
          this.getDataDebounced();
        },
      },
      entries: {
        handler(newEntries) {
          if (newEntries && newEntries.length > 0) {
            this.fetchActivityData();
          }
        },
      },
    },
    components: {
      UserAvatar,
      CompanyTypeC,
      EditCompany,
      CountProgress,
      ActivitySparkline,
      ActivityLevelModal
    },
  };
</script>
